import { createFileRoute } from "@tanstack/react-router";
import { CityLandingPage, buildCityLandingHead, type CityLandingConfig } from "@/components/CityLandingPage";

const CONFIG: CityLandingConfig = {
  slug: "greeley",
  name: "Greeley",
  region: "Northern Colorado",
  heroEyebrow: "Greeley Marketing Hub",
  heroTitle: { lead: "Greeley marketing for ", gold: "Weld County", trail: " businesses" },
  heroDescription:
    "Greeley anchors Weld County — agriculture, energy, healthcare, and a growing residential base. We build websites, SEO, and Map Pack programs for trades, ag-services, and downtown Greeley businesses competing in a regional, not metro, market.",
  intro:
    "Greeley isn't Denver — buyers here read reviews carefully, value local roots, and expect websites that work on a phone in a pickup truck. Our Greeley work is built for that buyer: fast, plainspoken, click-to-call ready, and proof-heavy.",
  neighborhoods: [
    "Downtown Greeley",
    "West Greeley",
    "Promontory",
    "Boomerang",
    "Centerplace",
    "St. Michael's",
    "University District",
    "Evans-adjacent",
  ],
  marketSnapshot:
    "Greeley's Map Pack is regionally competitive — fewer competitors than Denver but stickier incumbents and a buyer base that distrusts national chains. Wins come from local proof, review velocity, and a website that loads fast on rural LTE.",
  highlights: [
    {
      title: "Regional, not metro, playbook",
      body: "Greeley SEO is different from Denver SEO — fewer competitors, longer consideration cycles, more weight on reviews. We tune for the actual market.",
    },
    {
      title: "Weld County service-area coverage",
      body: "Most Greeley businesses serve Evans, Windsor, Eaton, and Loveland. We rank you across the real footprint, not just 80631.",
    },
    {
      title: "Beat the chains on local credibility",
      body: "National chains target Greeley with thin pages. We out-detail them with real local content that ranks above their templates.",
    },
  ],
  services: [
    { to: "/greeley-digital-marketing", title: "Greeley digital marketing", body: "Integrated SEO, GBP, and Ads programs for Greeley trades, ag-services, and downtown retail." },
    { to: "/colorado-springs-google-maps", title: "Google Maps optimization", body: "GBP optimization, citation cleanup, and review programs that move you into the Greeley 3-pack." },
    { to: "/colorado-springs-ppc", title: "Google Ads management", body: "Greeley PPC that doesn't burn budget on tire-kicker clicks. Conversion-focused, transparently reported." },
    { to: "/contractor-seo-fort-collins", title: "Contractor SEO", body: "Industry-specific SEO playbooks for Northern Colorado contractors and trades." },
  ],
  learnArticleSlugs: [
    "/learn/local-seo-guide",
    "/learn/google-business-profile",
    "/learn/website-conversion",
    "/learn/get-more-reviews",
    "/learn/marketing-budget",
    "/learn/seo-vs-ppc",
  ],
  learnIntro:
    "Greeley owners win on local credibility, not national polish. These six pieces explain how to compound that credibility online.",
  closingCta:
    "30-minute call. We'll audit your Greeley Map Pack position, look at how the chains are targeting you, and tell you the one move that pays back first.",
};

export const Route = createFileRoute("/greeley")({
  head: () =>
    buildCityLandingHead(CONFIG, {
      metaTitle: "Greeley Marketing Agency | SEO, Web Design & Maps | CWI",
      metaDescription:
        "Greeley SEO, web design, and Google Maps optimization for Weld County businesses. Local Colorado team, transparent reporting, no long-term contracts.",
    }),
  component: () => <CityLandingPage config={CONFIG} />,
});
